<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        Pagamento cotação ({{ this.$route.params.id }}) - via pix QRCode
      </h1>
      <hr class="linha-amarela" />
    </div>
    <div v-if="response.status == 'paid'" class="col-12">
      <h1 class="font-weight-bold text-uppercase color-success">Pagamento realizado com sucesso</h1>
    </div>
    <div :class="response.status == 'pending' ? 'card col-12 mb-5' : 'd-none'">
      <div class="card-body d-flex justify-content-center align-items-center">
        <qrcode-vue :value="value" :size="size" level="H" />
      </div>
      <div class="card-footer text-center">
        <b-button class="btn-success mb-2" @click="copyToClipboard()">Clique aqui para copiar</b-button>
        <div class="col-12">
          <span class="mt-4" v-if="copy">{{ this.copy }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import QrcodeVue from 'qrcode.vue';

  export default {
    data() {
      return {
        value: '',
        copy: '',
        response: [],
        size: 250,
      }
    },
    components: {
      QrcodeVue,
    },
    mounted() {
      this.loadPayment();
    },
    methods: {
      copyToClipboard() {
        navigator.clipboard.writeText(this.value);
        this.copy = 'Copiado com sucesso!'
      },
      loadPayment() {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('emptyCotacao')
        .then(() => {
          this.$store
            .dispatch('showCheckoutCancel', this.$route.params.id)
            .then((data) => {
              const response = data.data;
              this.value = response.pix.qrcode_text;
              this.response = response;
            })
            .catch(() => {
              this.$store.dispatch('endLoader');
            })
            .finally(() => this.$store.dispatch('endLoader'));
        });
      },
    }
  }
</script>
<style scoped>
  .color-success {
    color: rgb(237, 118, 70);
  }
</style>